<div *ngIf="checkAbilitato && abilitato" class="padd-1">
  <div *ngIf="tipovisita && ricercaFatta && !loading">
    <div class="container-immagine">
      <div class="overlay"></div>
      <img src="{{ tipovisita.imgsrc }}" class="imgTipoVisita" alt="" />
    </div>

    <div class="mt-1">
      <app-note-termini
        [note]="cantina.note_base"
        [termini]="cantina.termini_cancellazione"
      ></app-note-termini>
      <div class="head">{{ tipovisita.titolo }}</div>
      <app-testo-espandibile
        [text]="tipovisita.descrizione"
      ></app-testo-espandibile>
    </div>
    <div class="prenotazione mt-1">
      <div class="head">Personalizza il tuo regalo</div>
      <div>
        <div [formGroup]="form">
          <mat-form-field matInput class="w-100" maxlength="160">
            <mat-label>Messaggio personalizzato</mat-label>
            <textarea
              matInput
              placeholder="No emoji"
              [formControl]="messaggioFormControl"
            ></textarea>
            <mat-hint align="end"
              >{{ form.value.messaggio.length }} / 160
            </mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div fxLayout="column">
      <div class="continua">
        <hr class="mb-1" />
        <div class="head mb-1 mt-2">
          {{ "base.riepilogo" | translate }}
        </div>
        <div class="riepilogo">
          <div class="riepilogo__line">
            <div class="riepilogo__label">Nr. posti</div>
            <div class="riepilogo__value">
              <div class="flex-buttons">
                <button
                  mat-stroked-button
                  class="buttonPosti"
                  (click)="adultiMeno()"
                >
                  <span class="material-symbols-outlined"> remove </span>
                </button>
                <label class="labelposti">{{ adulti }}</label>
                <button
                  mat-stroked-button
                  class="buttonPosti"
                  (click)="adultiPiu()"
                >
                  <span class="material-symbols-outlined"> add </span>
                </button>
              </div>
            </div>
          </div>
          <div class="riepilogo__line">
            <div class="riepilogo__label">
              {{ "step1.totale" | translate }}
            </div>
            <div class="riepilogo__value total">
              € {{ totale | number : "1.2-2" }}
            </div>
          </div>
        </div>
        <div class="flex-actions mt-2">
          <button
            class="btn buttonContinua"
            (click)="gestisciAzioneContinua()"
            [disabled]="!form.valid"
          >
            {{ "base.aggiungi_carrello" | translate }}
            <span class="material-symbols-outlined"> shopping_bag </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!tipovisita && ricercaFatta && !loading" class="nores">
    <div class="nores-title">{{ "base.nessuna_visita_title" | translate }}</div>
    <div
      class="nores-subtitle"
      [innerHTML]="
        'base.nessuna_visita_subtitle' | translate : { value: denominazione }
      "
    ></div>
  </div>
  <div *ngIf="loading">
    <app-step1-loading></app-step1-loading>
  </div>
</div>
<div *ngIf="checkAbilitato && !abilitato && !loading" class="padd-1">
  <div class="nores-text cantina-name">
    <strong>
      {{ nonabilitatoMsg | translate }}
    </strong>
  </div>
  <img src="../../assets/img/ko.png" alt="" class="w-100" />
  <div class="nores-text cantina-name">
    <strong>
      {{ nonabilitatoMsg | translate }}
    </strong>
  </div>
</div>
